import cloneDeep from 'lodash/cloneDeep';
import ttpConfig from './ttp';
var config = cloneDeep(ttpConfig);
export default config;